import React from 'react';
import { Label } from '../ui/label';

interface CustomCheckboxProps {
  id?: string;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  name?: string;
}

const CustomCheckbox = React.forwardRef<HTMLInputElement, CustomCheckboxProps>(
  (
    {
      id,
      checked = false,
      onCheckedChange,
      onChange,
      label,
      className = '',
      disabled = false,
      name,
      ...props
    },
    ref
  ) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const isChecked = event.target.checked;
      onCheckedChange?.(isChecked);
      onChange?.(event);
    };

    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        <input
          ref={ref}
          id={id}
          name={name}
          type='checkbox'
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className='h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 focus:ring-2 disabled:opacity-50'
          {...props}
        />
        {label && (
          <Label
            htmlFor={id}
            className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
          >
            {label}
          </Label>
        )}
      </div>
    );
  }
);

CustomCheckbox.displayName = 'CustomCheckbox';

export default CustomCheckbox;
